// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"81401b53","501":"588b971b","925":"26a67ad9"}[chunkId] + ".chunk.js";
};